<template>
  <div id="global-scan">
    <v-quagga
      v-if="!bar_code"
      :multiple="false"
      :torch="false"
      :onDetected="getBarcode"
      :inputStream="{
        constraints: {
          /* width: 1280,
          height: 480 */
        },
      }"
      :singleChannel="false"
      :readerSize="readerSize"
      :readerTypes="[
        'ean_reader',
        'ean_8_reader',
        'upc_reader',
        'upc_e_reader'
      ]"
    />
  </div>
</template>
<script>
import VQuagga from '@/quagga/QuaggaScanner';
export default {
  props: ['isGlobalScanner', 'readerSize'],
  components: {
    VQuagga,
  },
  data() {
    return {
      bar_code: false,
      orderId: '',
    };
  },

  methods: {
    getOrderIdFromInput(_event) {
      if (_event.target.value) {
        this[_event.target.name] = _event.target.value;
      } else {
        this.bar_code = false;
        this[_event.target.name] = '';
      }
    },

    emitOrderId() {
      this.$emit('orderId', this['orderId'].trim());
    },

    getBarcode(data) {
      this.bar_code = data.codeResult.code.trim();
      this.$emit('orderId', this.bar_code);
    },

    closeScanner() {
      this.$emit('closeScanner');
    },
  },
  mounted() {
    let _this = this;
  },
};
</script>
<style lang="scss" scoped></style>
